import React, { useState } from 'react';
import InputRegister from 'components/InputRegister';
import { deleteUser, closeErrorUser } from 'store/actions/userActions';
import Modal from 'components/Modal';
import { useDispatch, useSelector } from 'react-redux';
import * as S from '../../Register/Register.Styled';

function DeleteAccount({ onCancel }) {
	const dispatch = useDispatch();

	const { messageDelete, loadingDelete } = useSelector((state) => state.user);

	const [password, setPassword] = useState('');

	const handleDelete = (e) => {
		e.preventDefault();
		dispatch(deleteUser({ password }));
	};

	const handleClose = () => {
		dispatch(closeErrorUser());
	};

	return (
		<>
			<S.Title> Deseja excluir a sua conta?</S.Title>
			<S.Message>
				Se você decidir excluir sua conta, é importante saber que todas as suas informações de usuário e registros serão
				permanentemente apagados após 30 dias. Você pode reativar sua conta a qualquer momento dentro desse período.
			</S.Message>
			<form onSubmit={handleDelete}>
				<S.Label>Senha</S.Label>
				<InputRegister type="password" value={password} setValue={setPassword} autoComplete="new-password" required />

				<S.BoxButton>
					<S.Button type="submit">{loadingDelete ? 'Aguarde...' : 'Excluir minha conta'}</S.Button>
				</S.BoxButton>

				<S.BoxButton>
					<S.ButtonTransparent type="button" onClick={onCancel}>
						Não quero excluir
					</S.ButtonTransparent>
				</S.BoxButton>
			</form>
			<Modal isOpen={messageDelete?.length > 0} setIsOpen={handleClose} useBtnEnd={false}>
				{messageDelete}
			</Modal>
		</>
	);
}

export default DeleteAccount;
